export const GET_POSTS_TITLES = 'GET_POSTS_TITLES';
export const GET_POST_DETAIL = 'GET_POST_DETAIL';
export const ADD_POST = 'ADD_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const ADD_COMMENT = 'ADD_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const SHOW_ERROR = 'SHOW_ERROR';
export const VOTE = 'VOTE';
